// extracted by mini-css-extract-plugin
export default {"documentModal":"ModalDocumentPdf_documentModal__XKRMt","contentDocument":"ModalDocumentPdf_contentDocument__TEszq","btnCloseModal":"ModalDocumentPdf_btnCloseModal__dXVyt"};